import { Navigate, generatePath } from 'react-router-dom';

import { useRoutepaths } from '@/router/hooks/useRoutePaths';

export function SignInNavigation({ hasPassphrase }: { hasPassphrase: boolean }) {
  const PathRoute = useRoutepaths();

  if (!hasPassphrase) return <Navigate to={generatePath(PathRoute.auth.root, { '*': PathRoute.auth.passphrase })} />;
  return <Navigate to={generatePath(PathRoute.app.root, { '*': PathRoute.app.users.main })} />;
}
